import script from "./audios.vue?vue&type=script&setup=true&lang=ts"
export * from "./audios.vue?vue&type=script&setup=true&lang=ts"

import "./audios.vue?vue&type=style&index=0&id=9607a482&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9607a482"]])

export default __exports__